import SubCategoriesService2 from './SubCategoriesService2';

export {default} from './SubCategoriesService2';
export const subCategoriesService2 = new SubCategoriesService2();